import React, { useState } from "react";
import { Button, Checkbox, Form, Input, Modal, Select, Space, Switch, Upload, Image } from 'antd';
import { MinusCircleOutlined, PlusOutlined, UploadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { menuItems } from "../../secondUtils/constants";
import { assignLanguage } from "../../utils/helpers";
import { useSelector } from "react-redux";
import dentalStoreProductImg from "../../secondAssets/Images/dentalStoreProductImg.jpeg"
import dentalStoreProductNameImg from "../../secondAssets/Images/dentalStoreProductNameImg.jpeg"
import dentalStoreProductPriceImg from "../../secondAssets/Images/dentalStoreProductPriceImg.jpeg"

const { Option } = Select

const ContentFormDentalStore = ({ path, setPath, props }) => {
    const language = useSelector(state => state?.languageReducer)
    const selectedLanguage = assignLanguage(language?.language)
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [form] = Form.useForm()
    const [modalVisible, setModalVisible] = useState(false)
    const [dataForModal, setDataForModal] = useState()
    const showModal = () => {
        setModalVisible(true)
    }

    const handleCancel = () => {
        setModalVisible(false)
    }
    const handleChange = (value) => {
        setPath(value);
        console.log('value', value)
    };
    const onFinish = async (values) => {
        let formData = new FormData()
        console.log('formData', values)
        setDataForModal(values)

    }
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };
    return (
        <div className="main">
            <div className="content-form">
                <Form
                    initialValues={{ screen: path }}
                    form={form}
                    onFinish={onFinish}
                    layout='vertical'
                    requiredMark={true}
                >
                    <div className="content-form-logo-and-selectScreen-div">
                        <div>
                            <h2 className="content-form-heading">
                                {selectedLanguage?.txt_content_form_dental_store}
                            </h2>
                        </div>
                        <div>
                            <Form.Item
                                name='screen'
                                label={selectedLanguage?.txt_select_screen}
                                rules={[
                                    {
                                        required: true,
                                    },
                                ]}
                            >
                                <Select
                                    showArrow
                                    showSearch
                                    allowClear
                                    placeholder={selectedLanguage?.txt_select_screen}
                                    optionFilterProp='children'
                                    filterOption={true}
                                    onChange={handleChange}
                                >
                                    {menuItems.slice(0, -2).map((item, index) => (
                                        <React.Fragment key={index}>
                                            <Option value={item.menuName}>
                                                {isELSelect ? item?.menuName : (isAlSelect ? item?.menuALName : item?.menuGLName)}
                                            </Option>
                                            {item.submenu ? item.submenu.map((sub, subIndex) => (
                                                <Option key={`${index}-${subIndex}`} value={sub.name} style={{ paddingLeft: '20px' }}>
                                                    {isELSelect ? sub?.name : (isAlSelect ? sub?.alName : sub?.glName)}
                                                </Option>
                                            )) : null}
                                        </React.Fragment>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                    </div>
                    <div className="content_sections_div">
                        <h2>{selectedLanguage?.txt_dental_store}</h2>
                        <Form.List name='dentalStoreItem' initialValue={[{ productImg: null, productName: null,productPrice:null }]}>
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(({ key, name, ...restField }) => (
                                        <Space
                                            className="formList-main"
                                            key={key}
                                            style={{
                                                display: 'flex',
                                                marginBottom: 8,
                                                flexWrap: 'wrap'
                                            }}
                                        >
                                            <Form.Item
                                                className="content-form-logo-div"
                                                label={selectedLanguage?.txt_add_product_image}
                                                {...restField}
                                                name={[name, 'productImg']}
                                                valuePropName='fileList'
                                                getValueFromEvent={normFile}
                                            >
                                                <Upload
                                                    maxCount={1}
                                                    multiple={true}
                                                    accept='image/*'
                                                    name='productImg'
                                                    action='/upload.do'
                                                    listType='text'
                                                    beforeUpload={() => false}
                                                >
                                                    <Button icon={<UploadOutlined />}>{selectedLanguage?.txt_upload}</Button>
                                                </Upload>
                                            </Form.Item>
                                            <Image
                                                width={150}
                                                src={dentalStoreProductImg}
                                            />
                                            <Form.Item
                                                className="content_inputs"
                                                {...restField}
                                                name={[name, 'productName']}
                                                label={selectedLanguage?.txt_product_name}
                                            >
                                                <Input placeholder={selectedLanguage?.txt_product_name} />
                                            </Form.Item>
                                            <Image
                                                width={150}
                                                src={dentalStoreProductNameImg}
                                            />
                                            <Form.Item
                                                className="content_inputs"
                                                {...restField}
                                                name={[name, 'productPrice']}
                                                label={selectedLanguage?.txt_product_price}
                                            >
                                                <Input type="number" placeholder={selectedLanguage?.txt_product_price} />
                                            </Form.Item>
                                            <Image
                                                width={150}
                                                src={dentalStoreProductPriceImg}
                                            />
                                            {fields.length > 1 ?
                                                <span style={name ? { marginTop: '5px', position: 'absolute' } : {}}>
                                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                                </span>
                                                :
                                                null
                                            }
                                        </Space>
                                    ))}
                                    <Form.Item>
                                        <Button style={{ marginTop: '20px' }} type='dashed' onClick={() => add()} block icon={<PlusOutlined />}>
                                            {selectedLanguage?.add_button_txt}
                                        </Button>
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                    </div>
                    <Form.Item
                        className="content_inputs"
                        name='remark'
                        rules={[
                            {
                                required: false,
                                message: '',
                            }
                        ]}
                        label={selectedLanguage?.txt_remark}
                    >
                        <Input.TextArea autoSize={{ minRows: 2 }} placeholder={selectedLanguage?.txt_remark} />
                    </Form.Item>
                    <Form.Item >
                        {/* <Button
                            onClick={showModal}
                            htmlType='submit'
                            style={{ borderRadius: 4, width: '100%', marginBottom: '20px' }}
                        // type='primary'
                        // loading={loading}
                        >
                            {'Preview'}
                        </Button> */}
                        <Button
                            htmlType='submit'
                            style={{ borderRadius: 4, width: '100%', marginTop: '25px' }}
                            type='primary'
                        // loading={loading}
                        >
                            {selectedLanguage?.submit_button}
                        </Button>
                    </Form.Item>
                </Form>
                {/* <HomeModal dataForModal={dataForModal} visible={modalVisible} onCancel={handleCancel} /> */}
            </div >
        </div >
    )
}

export default ContentFormDentalStore